import { render, staticRenderFns } from "./_buttons_col.vue?vue&type=template&id=1deb011f&"
import script from "./_buttons_col.vue?vue&type=script&lang=js&"
export * from "./_buttons_col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports